import { logger } from "../logger/logger";

/**
 * @private
 */
export const scrollToWindowTop = () => {
  window.scrollTo(0, 0);
  logger.info("Scrolling window to coordinates: 0, 0");
};
